import Border from "./border";
import Growing from "./growing";
const Spinner = {Border,Growing};

export default Spinner;